import client from "./client";

export const recruitView = (locale, studyId) =>
  client.get(`/api/${locale}/recruit/view?studyId=${studyId}`);

export const fileDown = (locale, fileId) =>
  client.get(`/api/${locale}/recruit/download?fileId=${fileId}`, {
    responseType: "arraybuffer"
  });
